import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';

interface IPracticeFooter {
  action: () => void;
}

export function PracticeFooter({ action }: IPracticeFooter) {
  return (
    <div className='bg-color-lightest fixed bottom-0 left-0 flex w-full flex-row py-4 shadow-level-1 xs:hidden xs:px-4 md:px-8 lg:block lg:px-[89px]'>
      <div className='flex w-full flex-row items-center justify-center gap-xl'>
        <Typography weight='bold'>Crie quantos simulados quiser!</Typography>
        <Button onClick={() => action()}>
          <Icon Icon='add' type='material' />
          Criar simulado
        </Button>
      </div>
    </div>
  );
}
